<template>
    <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <path d="M0 0h40v40H0z"/>
            <circle fill="#282828" fill-rule="nonzero" cx="17.5" cy="12.5" r="2.5"/>
            <rect fill="#282828" fill-rule="nonzero" x="15" y="17" width="5" height="13" rx="2.5"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconInfo',
};
</script>
